/* EXO – Drawer Cart (section-safe refresh, hardened, FINAL CONSOLIDATED) */
(function(){
  const $  = (s,r=document)=>r.querySelector(s);
  const $$ = (s,r=document)=>Array.from(r.querySelectorAll(s));

  let inflight=null;
  let listenersBound=false;
  let _drawerStateObserver=null; // FIX: evite les fuites
  const debounce=(fn,d=120)=>{let t;return(...a)=>{clearTimeout(t);t=setTimeout(()=>fn(...a),d);}};
 function exoGetActiveVariantId(form){
  const scope = form || document;

  // 1) radios bundle (data-variant OU data-variant-id)
  const r = scope.querySelector('.bundle-option input[type="radio"]:checked')
        || document.querySelector('.bundle-option input[type="radio"]:checked');
  if (r && (r.dataset.variant || r.dataset.variantId))
    return r.dataset.variant || r.dataset.variantId;

  // 2) sélecteurs natifs du thème
  const btn = scope.querySelector('[data-variant-id][aria-pressed="true"], input[type="radio"][data-variant-id]:checked')
        || document.querySelector('[data-variant-id][aria-pressed="true"], input[type="radio"][data-variant-id]:checked');
  if (btn && (btn.dataset.variantId || btn.dataset.variant))
    return btn.dataset.variantId || btn.dataset.variant;

  // 3) fallback : hidden déjà présent
  const hidden = scope.querySelector('input[name="id"]')
        || document.querySelector('.exo-bundle-form input[name="id"]');
  return hidden ? hidden.value : undefined;
}

/* --- renfort : au clic d’un bouton submit/add on écrit l’ID au plus tôt --- */
document.addEventListener('click', function(e){
  const btn = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"]');
  if (!btn) return;
  const form = btn.closest('form');
  try{ window.exoSetBundleProperties && window.exoSetBundleProperties(); }catch(_){}
  const idInput = form && form.querySelector('input[name="id"]');
  const vid = exoGetActiveVariantId(form);
  if (idInput && vid) idInput.value = vid;
}, true);

  function exoUpdateCheckoutButton(){
    const btn = $('#CartDrawer-Checkout');
    if (!btn) return;
    const subtotalEl = document.querySelector('.exo-cart-summary__row--subtotal .exo-cart-summary__money');
    /* 22/10/2026 — on ne reconstruit plus la chaine (elle effacerait les deux spans) : le montant seul. */
    const amount = btn.querySelector('[data-exo-cta-amount]');
    if (amount && subtotalEl) amount.textContent = subtotalEl.textContent.trim();
  }

  function dispatchCartUpdated(){
    // FIX: alimente les autres listeners (ex: header)
    try{
      const bubble = document.getElementById('cart-icon-bubble');
      let count = null;
      if (bubble) {
        if (bubble.hasAttribute('hidden')) count = 0;
        else {
          const n = parseInt((bubble.textContent||'').trim(),10);
          if (!Number.isNaN(n)) count = n;
        }
      }
      document.dispatchEvent(new CustomEvent('cart:updated',{ detail:{ item_count: count }}));
    }catch(_){}
  }

  function getSectionIds(){
    const host=$('#CartDrawer-Host')||$('cart-drawer')||document.body;
    const wrapper=host.closest('[id^="shopify-section"]');
    const drawerSectionId=wrapper?wrapper.id.replace('shopify-section-',''):'cart-drawer-section';

    let bubbleSectionId=null;
    const headerWrapper=($('#shopify-section-header')||$('header')?.closest('[id^="shopify-section"]'));
    if(headerWrapper) bubbleSectionId=headerWrapper.id.replace('shopify-section-','');

    const bubbleEl=$('#cart-icon-bubble, .cart-count-bubble');
    if(bubbleEl){
      const bubbleWrap=bubbleEl.closest('[id^="shopify-section"]');
      if(bubbleWrap) bubbleSectionId=bubbleWrap.id.replace('shopify-section-','');
    }
    return [drawerSectionId,bubbleSectionId].filter(Boolean).filter((v,i,a)=>a.indexOf(v)===i);
  }

  function focusDrawerTitle(){
    const el=$('#CartDrawer .drawer__title'); if(!el) return;
    el.setAttribute('tabindex','-1'); el.focus?.({preventScroll:true});
  }

  /* 22/10/2026 — INDICE DE DEFILEMENT. Le tiroir entier (.drawer__inner) est la zone defilante, en-tete et pied
     colles (CSS). Ici : trois classes d'etat sur <cart-drawer> (is-scrollable, is-at-end, is-scrolled) qui
     pilotent le fondu au-dessus du pied et l'ombre sous l'en-tete ; la pastille « Voir les N autres produits »
     compte les lignes dont le bas passe sous le pied ; scroll-padding pour que le focus clavier ne se cache
     ni sous l'en-tete ni sous le pied. Tout est relie a chaque re-rendu (le <cart-drawer> est remplace). */
  function exoCueUpdate(){
    const d=$('cart-drawer'); const inner=d&&d.querySelector('.drawer__inner'); if(!inner) return;
    const head=inner.querySelector('.drawer__header'), foot=inner.querySelector('.drawer__footer');
    const more=inner.querySelector('[data-exo-cart-more]');
    const max=inner.scrollHeight-inner.clientHeight;
    const scrollable=max>4;
    const atEnd=!scrollable||inner.scrollTop>=max-4;
    d.classList.toggle('is-scrollable',scrollable);
    d.classList.toggle('is-at-end',atEnd);
    d.classList.toggle('is-scrolled',inner.scrollTop>4);
    inner.style.scrollPaddingTop=(head?head.offsetHeight:0)+'px';
    inner.style.scrollPaddingBottom=(foot?foot.offsetHeight:0)+'px';
    if(!more) return;
    let n=0;
    if(!atEnd){
      const limit=foot?foot.getBoundingClientRect().top:inner.getBoundingClientRect().bottom;
      inner.querySelectorAll('.cart-drawer-item, .exo-cart-bundle-card').forEach(el=>{ if(el.getBoundingClientRect().bottom>limit+1) n++; });
    }
    if(n>0){
      const label=more.querySelector('[data-exo-cart-more-label]')||more;
      label.textContent=(n===1?more.dataset.one:more.dataset.other).replace('[count]',n);
      more.hidden=false;
    } else { more.hidden=true; }
  }
  function bindScrollCue(){
    const d=$('cart-drawer'); const inner=d&&d.querySelector('.drawer__inner'); if(!inner||inner.dataset.exoCue) return;
    inner.dataset.exoCue='1';
    let raf=0; const tick=()=>{ if(raf) return; raf=requestAnimationFrame(()=>{ raf=0; exoCueUpdate(); }); };
    inner.addEventListener('scroll',tick,{passive:true});
    if(window.ResizeObserver){ const ro=new ResizeObserver(tick); ro.observe(inner); const b=inner.querySelector('.cart-drawer__body'); if(b) ro.observe(b); }
    inner.querySelector('[data-exo-cart-more]')?.addEventListener('click',()=>{
      const head=inner.querySelector('.drawer__header'), foot=inner.querySelector('.drawer__footer');
      const step=Math.max(120, inner.clientHeight-(head?head.offsetHeight:0)-(foot?foot.offsetHeight:0)-40);
      const reduce=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      inner.scrollBy({top:step, behavior:reduce?'auto':'smooth'});
    });
    tick();
  }

  /* 22/10/2026 — le bandeau de consentement Shopify passe sous le tiroir ouvert (troisieme couche, en style
     inline !important ; les deux autres sont dans exo-cart-drawer.css, bloc « Z-index »). */
  function exoBannerBelowDrawer(open){
    $$('#shopify-pc__banner, .shopify-pc__banner__dialog, [id^="shopify-pc__banner"]').forEach(el=>{
      if(open) el.style.setProperty('z-index','1','important'); else el.style.removeProperty('z-index');
    });
  }

  function openDrawer(){
    const d=$('cart-drawer'); if(!d) return;
    (d.open?d.open():d.classList.add('active'));
    document.documentElement.classList.add('exo-cart-open','overflow-hidden');
    exoBannerBelowDrawer(true);
    requestAnimationFrame(()=>{ focusDrawerTitle(); exoCueUpdate(); });
  }

  function closeDrawer(){
    const d=$('cart-drawer'); if(!d) return;
    (d.close?d.close():d.classList.remove('active'));
    document.documentElement.classList.remove('exo-cart-open','overflow-hidden');
    exoBannerBelowDrawer(false);
  }

  function observeDrawerState(){
    const target=$('cart-drawer'); if(!target) return;
    if (_drawerStateObserver) { try{ _drawerStateObserver.disconnect(); }catch(_){} } // FIX
    const apply=()=>{
      const open=target.hasAttribute('open')||target.classList.contains('active');
      document.documentElement.classList.toggle('exo-cart-open',open);
      exoBannerBelowDrawer(open);
    };
    _drawerStateObserver=new MutationObserver(apply);
    _drawerStateObserver.observe(target,{attributes:true,attributeFilter:['class','open']});
    apply();
  }

  async function refreshSections(extra=[]){
    const ids=[...getSectionIds(),...extra].filter(Boolean);

    inflight?.abort?.();
    inflight=new AbortController();

    const url=`${location.pathname}?sections=${ids.join(',')}`;
    let data;
    try{
      const res=await fetch(url,{credentials:'same-origin',signal:inflight.signal,cache:'no-store'});
      data=await res.json();
    }catch{ return; }

    const wasOpen=!!($('cart-drawer')?.hasAttribute('open')||$('cart-drawer')?.classList.contains('active'));
    const parser=new DOMParser();

    ids.forEach(id=>{
      const html=data[id]; if(!html) return;
      const doc=parser.parseFromString(html,'text/html');

      const freshRoot=doc.querySelector('cart-drawer');
      if(freshRoot){
        /* 22/10/2026 — la position de lecture survit au re-rendu : changer la quantite du 8e article
           ne ramene plus le tiroir en haut. */
        const keepTop=$('cart-drawer .drawer__inner')?.scrollTop||0;
        /* 22/10/2026 — la jauge du franco PROGRESSE : le re-rendu remplace l'element, donc la transition CSS ne
           jouait jamais. On repart de l'ancienne largeur vers la nouvelle. */
        const oldFill=$('cart-drawer .exo-franco__fill'); const oldW=oldFill?oldFill.style.width:null;
        $('cart-drawer')?.replaceWith(freshRoot);
        const nf=$('cart-drawer .exo-franco__fill');
        if(nf&&oldW&&oldW!==nf.style.width){
          const target=nf.style.width;
          nf.style.transition='none'; nf.style.width=oldW; void nf.offsetWidth; nf.style.transition='';
          requestAnimationFrame(()=>{ nf.style.width=target; });
        }
        if(wasOpen){
          const n=$('cart-drawer');
          n?.classList.add('active');
          document.documentElement.classList.add('exo-cart-open','overflow-hidden');
          const ni=n?.querySelector('.drawer__inner'); if(ni&&keepTop) ni.scrollTop=keepTop;
        }
      }

      const freshBubble=doc.querySelector('#cart-icon-bubble, .cart-count-bubble');
      if(freshBubble){
        const oldBubble=$('#cart-icon-bubble, .cart-count-bubble');
        oldBubble?.replaceWith(freshBubble);
        freshBubble.classList.add('bump');
        setTimeout(()=>freshBubble.classList.remove('bump'),180);
        freshBubble.setAttribute('aria-live','polite');
      }
    });

    if(wasOpen) requestAnimationFrame(()=>{ focusDrawerTitle(); exoCueUpdate(); });
    observeDrawerState();
    bindScrollCue();                  // le <cart-drawer> vient d'etre remplace : indice de defilement a relier
    bindOneTimeListeners();           // rebind (guardé) après remount
    exoUpdateCheckoutButton();        // CTA label toujours à jour
    dispatchCartUpdated();            // FIX: notifier le header & co
    window.dispatchEvent(new Event('exo:reflow'));
  }
  const refreshDebounced=debounce(refreshSections,120);

  /* =========================
     Bind (one-time)
  ==========================*/
  /* 08/10/2026 — message de Shopify (422 a l'ajout) en tete du tiroir ; il part au prochain re-rendu. */
  function showCartNotice(msg){
    const host = $('#CartDrawer .cart-drawer__body') || $('#CartDrawer .drawer__inner') || $('#CartDrawer');
    if (!host) return;
    host.querySelectorAll('.exo-cart-notice').forEach(n=>n.remove());
    const p = document.createElement('p'); p.className = 'exo-cart-notice'; p.setAttribute('role','status'); p.textContent = msg;
    host.prepend(p);
  }
  function bindOneTimeListeners(){
    if(listenersBound) return; listenersBound=true;

    // Intercept add-to-cart (un seul handler propre)
    document.addEventListener('submit',(e)=>{
      const form=e.target.closest('form[action*="/cart/add"]'); 
      if(!form) return;
      e.preventDefault();

      // 1) Props bundle à coup sûr
      try { window.exoSetBundleProperties?.(); } catch(_){}

      // 2) Forcer la variante correcte (bundle > native > hidden)
      const idInput=form.querySelector('input[name="id"]');
      const vid = exoGetActiveVariantId(form);
      if (idInput && vid) idInput.value = vid;

      // 3) Add → refresh + open
      /* 08/10/2026 — L'AJOUT PASSE PAR `items`, QUE SHOPIFY CONTROLE. Le formulaire a plat (FormData) passait
         outre la disponibilite : six Rituels entraient avec trois en stock, et c'est le paiement qui refusait.
         Avec `items:[…]`, Shopify n'ajoute que le possible et repond 422 avec un message localise, que l'on
         montre en tete du tiroir. Filet derriere le plafond du champ (exo-bundle, cap_*). */
      const fd = new FormData(form);
      const item = { id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity') || '1', 10) || 1), properties: {} };
      for (const [k, v] of fd.entries()){ const m = k.match(/^properties\[(.+)\]$/); if (m) item.properties[m[1]] = v; }
      const sp = fd.get('selling_plan'); if (sp) item.selling_plan = Number(sp);
      let notice = '';
      /* Le message de Shopify suit la langue de l'URL appelee, pas celle de la page : sur /es et /en, un
         /cart/add.js a la racine repond en francais. On prefixe par la racine localisee. */
      /* La racine se lit sur l'URL de la page, pas sur Shopify.routes.root, qui a deja valu « /en/ » sur une page
         francaise (voir layout/theme.liquid, note de septembre). */
      const root = (location.pathname.match(/^\/[a-z]{2}(?:-[a-z]{2})?\//i) || ['/'])[0];
      fetch(root + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[item]}),credentials:'same-origin'})
        .then(async r=>{
          let data = null; try { data = await r.json(); } catch(_) {}
          if (r.ok) return;
          const msg = (data && (data.description || data.message)) || '';
          if (r.status === 422 && msg) { notice = msg; return; }
          throw new Error('add failed ' + r.status + ' ' + msg);
        })
        .then(()=>refreshSections())
        .then(()=>{ openDrawer(); if (notice) showCartNotice(notice); })
        .catch(console.error);
    });

    // Ouvrir / fermer
    document.addEventListener('click',(e)=>{
      if(e.target.closest(
        // FIX: ajoute .js-open-cart et la cible #CartDrawer
        '.js-open-cart, .header__icon--cart, [data-cart-toggle], [data-open-cart], [data-drawer-id="CartDrawer"], a[href="#cart-drawer"], a[href="#CartDrawer"], #cart-icon-bubble, .cart-count-bubble'
      )){
        e.preventDefault(); refreshSections().then(openDrawer);
      }
      if(e.target.closest('[data-close-cart], .drawer__close, #CartDrawer-Overlay, .cart-drawer__overlay')){
        e.preventDefault(); closeDrawer();
      }
    });

    // Qty +/- (drawer)
    document.addEventListener('click',(e)=>{
      const wrap = e.target.closest('#CartDrawer .exo-qty-controls'); if(!wrap) return;
      const input = wrap.querySelector('.qty-input'); if(!input) return;

      const plus  = e.target.closest('.qty-btn.plus');
      const minus = e.target.closest('.qty-btn.minus');
      if(!plus && !minus) return;

      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();

      const min  = parseInt(input.min || '1', 10) || 1;
      const max  = input.max ? parseInt(input.max, 10) : null;
      const step = parseInt(input.step || '1', 10) || 1;
      let val    = parseInt(input.value || String(min), 10) || min;

      if(plus)  val += step;
      if(minus) val = Math.max(min, val - step);
      if(max)   val = Math.min(max, val);

      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles:true }));
    });

    // Change qty → update cart
    /* 08/10/2026 — UNE SEULE REQUETE EN VOL, ET C'EST LE DERNIER ETAT QUI PART. Avant : un /cart/update.js
       par changement, sans verrou ; dix clics rapides = dix requetes concurrentes dont les reponses
       reviennent dans le desordre, et le re-rendu montrait l'etat de la derniere traitee, pas du dernier
       clic (bug confirme par Abdoul). Maintenant : temporisation de 300 ms, puis une requete qui lit le
       formulaire au moment de partir ; un changement pendant le vol marque « a renvoyer » ; le re-rendu
       n'a lieu qu'une fois la file vide. Tout nouveau changement annule un rafraichissement en vol, qui
       remplacerait sinon la valeur affichee par une valeur deja perimee. */
    let qtyTimer=null, qtyInFlight=false, qtyDirty=false;
    async function pushQty(){
      const form = $('#CartDrawer-Form'); if(!form) return;
      if(qtyInFlight){ qtyDirty=true; return; }
      qtyInFlight=true; qtyDirty=false;
      try{
        await fetch('/cart/update.js', { method:'POST', body:new FormData(form), credentials:'same-origin' });
      }catch(err){ console.error(err); }
      qtyInFlight=false;
      if(qtyDirty){ qtyDirty=false; return pushQty(); }
      refreshSections();
    }
    document.addEventListener('change',(e)=>{
      const input = e.target.closest('#CartDrawer .qty-input'); if(!input) return;
      inflight?.abort?.();
      clearTimeout(qtyTimer); qtyTimer=setTimeout(pushQty, 300);
    });

    // Remove line
    document.addEventListener('click',(e)=>{
      const btn=e.target.closest('#CartDrawer [id^="CartDrawer-Remove-"] button'); if(!btn) return;
      e.preventDefault();
      const link=btn.closest('cart-remove-button')?.querySelector('a[href*="cart/change"]')||btn.closest('a,button');
      if(link?.href){
        fetch(link.href,{credentials:'same-origin'})
          .then(()=>refreshSections())
          .catch(console.error);
      }
    });

    // A11y focus/escape + trap tab
    document.addEventListener('keydown',(e)=>{
      const drawer=$('cart-drawer');
      const isOpen=drawer&&(drawer.hasAttribute('open')||drawer.classList.contains('active'));
      if(!isOpen) return;

      if(e.key==='Escape'){ e.preventDefault(); closeDrawer(); return; }

      if(e.key==='Tab'){
        const focusables=$$('#CartDrawer a,#CartDrawer button,#CartDrawer input,#CartDrawer textarea,#CartDrawer [tabindex]:not([tabindex="-1"])')
          .filter(el=>!el.hasAttribute('disabled')&&el.offsetParent!==null);
        if(focusables.length<2) return;
        const first=focusables[0], last=focusables[focusables.length-1];
        if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
    });

    // Fallback focus-in → garder la classe sur <html>
    document.addEventListener('focusin', (e)=>{
      const d = e.target.closest && e.target.closest('#CartDrawer, cart-drawer');
      if (d) document.documentElement.classList.add('exo-cart-open','overflow-hidden');
    });
  }

  // Boot
  bindOneTimeListeners();
  observeDrawerState();
  bindScrollCue();

  // Expose publics pour autres scripts (ou icônes header)
  window.refreshSections = refreshSections;
  window.openDrawer      = openDrawer;
  window.closeDrawer     = closeDrawer;
})();

(function(){
  function getActiveBundleRadio(scope){
    return (scope || document).querySelector('.exo-bundle-form .bundle-option input[type="radio"]:checked');
  }
  function forceVariantId(form){
    try{
      const r = getActiveBundleRadio(form);
      const idInput = form && form.querySelector('input[name="id"]');
      if (idInput && r && r.dataset.variant) { idInput.value = r.dataset.variant; }
    }catch(_){}
  }

  /* 1) Quand l’utilisateur change de pack → on écrit l’ID tout de suite */
  document.addEventListener('change', function(e){
    const r = e.target.closest('.exo-bundle-form input[type="radio"][name="bundle_option"]');
    if (!r) return;
    const form = r.closest('form');
    forceVariantId(form);
  });

  /* 2) Juste avant l’add-to-cart (clic sur CTA dans le form) */
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.exo-bundle-form button[type="submit"], .exo-bundle-form .exo-cta-button, .exo-bundle-form [data-main]');
    if (!btn) return;
    const form = btn.closest('form');
    try{ window.exoSetBundleProperties && window.exoSetBundleProperties(); }catch(_){}
    forceVariantId(form);
  }, true);

  /* 3) Sécurité ultime à la soumission */
  document.addEventListener('submit', function(e){
    const form = e.target.closest('.exo-bundle-form[action*="/cart/add"]');
    if (!form) return;
    try{ window.exoSetBundleProperties && window.exoSetBundleProperties(); }catch(_){}
    forceVariantId(form);
  }, true);
})();

document.addEventListener('click', function(e){
  const btn = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], .exo-bundle-form [data-main]');
  if (!btn) return;
  const form = btn.closest('form');
  try{ window.exoSetBundleProperties && window.exoSetBundleProperties(); }catch(_){}
  const idInput = form && form.querySelector('input[name="id"]');
  const vid = exoGetActiveVariantId(form);
  if (idInput && vid) idInput.value = vid;
}, true);

/* ═══════════════════════════════════════════════════════════════
   V4.3 Session C2 — Suppression bulk d'un bundle entier
   Au clic sur [data-exo-bundle-remove], on supprime toutes les line
   items partageant le même _bundle_id via fetch séquentiel
   /cart/change.js avec id=item.key (stable, résiste aux réindexations).
   Event delegation sur document → robuste aux re-renders du drawer.
   ═══════════════════════════════════════════════════════════════ */
(function(){
  const BTN_SELECTOR  = '[data-exo-bundle-remove]';
  const CARD_SELECTOR = '.exo-cart-bundle-card';

  /**
   * Tracking analytics best-effort. Silencieux si aucun global n'est présent.
   * Capture les 3 plateformes que DERMALYS utilise potentiellement : GA4 (dataLayer),
   * Meta Pixel (fbq), Klaviyo (klaviyo). Aucune erreur ne remonte si l'un manque.
   */
  function trackBundleRemove(bundleId, bundleLabel, bundleTotal){
    const payload = {
      bundle_id: bundleId,
      bundle_label: bundleLabel,
      bundle_total: bundleTotal
    };
    try{
      if (window.dataLayer && typeof window.dataLayer.push === 'function'){
        window.dataLayer.push(Object.assign({ event: 'remove_bundle' }, payload));
      }
    }catch(_){}
    try{
      if (typeof window.fbq === 'function'){
        window.fbq('trackCustom', 'remove_bundle', payload);
      }
    }catch(_){}
    try{
      if (window.klaviyo && typeof window.klaviyo.push === 'function'){
        window.klaviyo.push(['track', 'Remove Bundle', payload]);
      }
    }catch(_){}
  }

  document.addEventListener('click', async function(e){
    const btn = e.target.closest(BTN_SELECTOR);
    if (!btn) return;

    e.preventDefault();

    const card     = btn.closest(CARD_SELECTOR);
    const bundleId = btn.getAttribute('data-exo-bundle-remove') || '';
    const keysAttr = btn.getAttribute('data-bundle-keys') || '';
    const keys     = keysAttr.split(',').map(function(k){ return k.trim(); }).filter(Boolean);

    if (!keys.length){
      console.error('[exo-cart] No bundle keys to remove for', bundleId);
      return;
    }

    // Capture label/total AVANT le fetch (DOM sera replacé par refreshSections)
    const bundleLabel = card
      ? (card.querySelector('.exo-cart-bundle-card__title')?.textContent?.trim() || '')
      : '';
    const bundleTotal = card
      ? (card.querySelector('.exo-cart-bundle-card__row:not(.exo-cart-bundle-card__row--saving) .exo-cart-bundle-card__money')?.textContent?.trim() || '')
      : '';

    // État visuel : opacity 50% + pointer-events none (gérés par le CSS via .is-removing)
    card?.classList.add('is-removing');
    btn.setAttribute('disabled', 'disabled');

    // Suppression atomique via /cart/update.js (1 round-trip, transaction Shopify atomique).
    // Avant : N fetch /cart/change.js séquentiels (3× pour Trio ~450-900ms, partial state si échec en cours).
    // Après : 1 fetch /cart/update.js avec updates {key1:0, key2:0, key3:0} (~150-300ms, all-or-nothing).
    let allOk = true;
    const updates = {};
    keys.forEach(function(key){ updates[key] = 0; });

    try{
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates }),
        credentials: 'same-origin'
      });
      if (!res.ok){
        allOk = false;
        console.error('[exo-cart] Bundle remove failed, status', res.status);
      }
    }catch(err){
      allOk = false;
      console.error('[exo-cart] Bundle remove fetch error', err);
    }

    if (allOk){
      // Tracking analytics (best-effort, non bloquant)
      trackBundleRemove(bundleId, bundleLabel, bundleTotal);

      // Refresh sections drawer + bubble compteur (fonction exposée à exo-cart-drawer.js:283)
      if (typeof window.refreshSections === 'function'){
        try{ await window.refreshSections(); }catch(_){}
      }
    } else {
      // Rollback visuel si échec — retirer .is-removing + ré-enable le bouton
      // (Backlog V4.4 : ajouter un toast UI d'erreur si demandé par CMO)
      card?.classList.remove('is-removing');
      btn.removeAttribute('disabled');
    }
  });
})();

/* ═══════════════════════════════════════════════════════════════
   V4.3.2 — Sync drawer au retour depuis BFCache (back navigation)
   Quand l'utilisateur revient sur la page via "Précédent" navigateur
   après être passé sur /checkout, le navigateur restaure la page
   depuis le BFCache et le compteur du drawer est stale.
   ═══════════════════════════════════════════════════════════════ */
window.addEventListener('pageshow', function(event){
  if (event.persisted){
    if (typeof window.refreshSections === 'function'){
      try{ window.refreshSections(); }catch(_){}
    }
  }
});

/* -- Quantite avant ajout (23/09/2026) : les deux boutons encadrent le champ lu par l'ajout. -- */
document.addEventListener('click', function (e) {
  var pas = e.target.closest('[data-exo-qty-minus], [data-exo-qty-plus]');
  if (!pas) return;
  var champ = pas.parentElement ? pas.parentElement.querySelector('[data-exo-qty-input]') : null;
  if (!champ) return;
  var n = parseInt(champ.value, 10) || 1;
  n = pas.hasAttribute('data-exo-qty-plus') ? n + 1 : n - 1;
  if (n < 1) n = 1;
  if (n > 99) n = 99;
  champ.value = n;
}, { passive: true });

/* ── Completez votre rituel (22/09/2026) : ajout direct depuis une carte de suggestion ── */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-exo-compl-add]'); if (!b || b.disabled) return;
  /* 23/09/2026 — l'etat d'origine se capture AVANT la requete : il sert aussi bien au succes qu'a l'echec. */
  var orig = b.innerHTML;
  var qtyField = b.parentElement ? b.parentElement.querySelector('[data-exo-qty-input]') : null;
  var qty = qtyField ? Math.max(1, parseInt(qtyField.value, 10) || 1) : 1;
  b.disabled = true;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-exo-compl-add')), quantity: qty }] }) })
  .then(function (r) {
    /* 23/09/2026 — un refus se LIT. Avant, `if (!r.ok) throw` puis un `catch` muet reactivaient le
       bouton sans un mot : le clic paraissait ignore. Shopify renvoie un corps JSON qui dit pourquoi
       (`description`), et c'est cette phrase qu'on montre et qu'on journalise. */
    if (!r.ok) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        var err = new Error(j.description || j.message || ('HTTP ' + r.status));
        err.detail = j; err.httpStatus = r.status; throw err;
      });
    }
    return r.json();
  })
  .then(function () {
    b.classList.add('is-added'); b.textContent = b.getAttribute('data-added-label') || b.textContent;
    /* bouton principal d'une fiche (data-exo-compl-reset) : il reprend son etat, un deuxieme ajout reste possible */
    if (b.hasAttribute('data-exo-compl-reset')) { setTimeout(function () { b.disabled = false; b.classList.remove('is-added'); b.innerHTML = orig; }, 1600); }
    if (typeof window.refreshSections === 'function' && typeof window.openDrawer === 'function') { return window.refreshSections().then(window.openDrawer); }
    window.location.reload();
  })
  .catch(function (err) {
    b.disabled = false;
    var raison = (err && err.message) ? String(err.message) : '';
    console.error('[EXO] ajout au panier refuse', (err && err.httpStatus) || '', raison, (err && err.detail) || '');
    b.classList.add('is-error');
    b.textContent = raison.slice(0, 70) || b.getAttribute('data-error-label') || '';
    setTimeout(function () { b.classList.remove('is-error'); b.innerHTML = orig; }, 5000);
  });
}, { passive: true });

/* ═══════════════════════════════════════════════════════════
   07/10/2026 — PALIER DE FORMAT SUR UNE LIGNE (tiroir et page panier)
   [data-exo-palier-swap] est rendu par snippets/exo-palier-ligne.liquid avec tout ce qu'il faut
   pour remplacer la ligne : la cle de ligne a retirer, la variante a ajouter, et les proprietes
   V3.9 PAR UNITE (_BaseCents, _Paid, _Free, _Total) du format propose. Deux appels : /cart/change.js
   (quantite 0 sur la cle, stable aux reindexations) puis /cart/add.js a la quantite 1. Le tiroir se
   rafraichit par sections ; la page panier se recharge.
   ═══════════════════════════════════════════════════════════ */
document.addEventListener('click', async function(e){
  const b = e.target.closest('[data-exo-palier-swap]'); if (!b) return;
  e.preventDefault(); e.stopPropagation();
  if (b.disabled) return;
  b.disabled = true;
  const d = b.dataset;
  const H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  try {
    let r = await fetch('/cart/change.js', { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify({ id: d.lineKey, quantity: 0 }) });
    if (!r.ok) throw new Error('palier: change ' + r.status);
    r = await fetch('/cart/add.js', { method: 'POST', headers: H, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(d.variant), quantity: 1,
      properties: { 'Pack': d.pack, 'Détails': d.details, '_BaseCents': d.base, '_Paid': d.paid, '_Free': d.free, '_Total': d.total } }] }) });
    if (!r.ok) throw new Error('palier: add ' + r.status);
    if (d.context === 'page' || typeof window.refreshSections !== 'function') { location.reload(); return; }
    await window.refreshSections();
  } catch (err) {
    console.error('[EXO] palier de format', err);
    b.disabled = false;
  }
}, true);
